import * as React from 'react';

import Flex from '@components/layout/flex';
import Button from '@components/actions/button';
import Typography from '@components/basics/typography';
import styled from 'styled-components';
import { getWidth } from '@components/styles';
import AppState from '@webapp/store/state';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { push, CallHistoryMethodAction } from 'connected-react-router';
import { GetSubscription } from '../../../../store/subscription/action-creators';
import { Translate } from 'react-localize-redux';
import moment, { Moment } from 'moment';

interface CurrentPlanCtrlProps {
  className?: string;
  plan: string;
  expiresAt?: Moment;
  artistId: string;
  currentSubscriptionId: string;
  getSubscription: (artistId: string) => GetSubscription;
  goToPlans: (clientId: string, id: string) => CallHistoryMethodAction;
}

const mapStateToProps = (state: AppState) => ({
  plan: state.subscription.current?.plan || '',
  currentSubscriptionId: state.subscription.current?.id || '',
  expiresAt: state.subscription.current?.ended_at
    ? moment(state.subscription.current?.ended_at)
    : undefined,
  artistId: state.artist.active?.id || '',
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getSubscription: (artistId: string) =>
    dispatch(new GetSubscription(artistId)),
  goToPlans: (clientId: string, id: string) =>
    dispatch(push(`/plans/${clientId}/${id}`)),
});

export const CurrentPlanCtrl: React.FC<CurrentPlanCtrlProps> = (props) => {
  const { getSubscription, artistId, currentSubscriptionId } = props;

  React.useEffect(() => {
    getSubscription(artistId);
  }, [getSubscription, artistId]);

  return (
    <Flex className={props.className}>
      <div className="text-wrapper">
        <Typography color="white" type="title" weight="700" margin="0 0 8px 0">
          <Translate id="ARTIST_PROFILE.BILLING.PLAN.TITLE" />: {props.plan}
        </Typography>
        {!props.plan.toUpperCase().includes('PRO') && (
          <Typography color="white" opacity=".5" type="small">
            <Translate id="ARTIST_PROFILE.BILLING.PLAN.TEXT" />
          </Typography>
        )}
        {props.expiresAt ? (
          <Typography className="mt-5" color="white" opacity=".75" type="small">
            Active until: {props.expiresAt.format('LL')}
          </Typography>
        ) : null}
      </div>
      <Button
        className="btn"
        buttonType="white"
        small
        onClick={() => props.goToPlans(artistId, currentSubscriptionId)}
      >
        {!props.plan.toUpperCase().includes('PRO') ? (
          <Translate id="ARTIST_PROFILE.BILLING.PLAN.BTN.OTHER" />
        ) : (
          <Translate id="ARTIST_PROFILE.BILLING.PLAN.BTN.PRO" />
        )}
      </Button>
    </Flex>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(CurrentPlanCtrl)`
  position: relative;
  padding: 15px;
  box-shadow: ${({ theme }) =>
    `${theme.general.boxShadowInput} ${theme.colors.shadow}`};
  border-radius: ${({ theme }) => theme.general.borderRadius};
  background: ${({ theme }) =>
    `linear-gradient(280deg, ${theme.colors.gray} 30%, ${theme.colors.black} 60%)`};
  z-index: 1;

  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  @media ${({ theme }) => theme.device.laptopL} {
    flex-direction: row;
  }

  @media ${({ theme }) => theme.device.tablet} {
    padding: 30px;
  }

  .text-wrapper {
    width: 100%;
    margin-bottom: 10px;

    @media ${({ theme }) => theme.device.laptopL} {
      margin-right: 20px;
      margin-bottom: 0;
      max-width: calc(100% - ${getWidth(2)} - 20px);
    }
  }

  .btn {
    position: relative;
    overflow: hidden;
    width: 100%;

    @media ${({ theme }) => theme.device.laptopL} {
      max-width: ${getWidth(2)};
    }
  }
`);
